import(/* webpackMode: "eager", webpackExports: ["IS_SAFARI","IS_IOS","IS_APPLE_WEBKIT"] */ "/tmp/build_625ec67b/node_modules/@payloadcms/richtext-lexical/dist/lexical/utils/environment.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_625ec67b/src/app/(frontend)/order/_components/form.tsx");
